<template>
  <div>
    <div
      v-for="event in events"
      :key="event._id"
      class="rounded-12px shadow-md mb-6"
    >
      <div
        class="flex py-8 rounded-12px"
        :class="[event._id === selectedEvent._id ? 'bg-ffe1' : 'bg-f9f9f9']"
      >
        <div class="flex w-5/6 items-center">
          <div
            class="text-center bor-baju text-8f8f8f px-8 py-4 w-1/3"
            :class="[
              event._id === selectedEvent._id ? 'bg-primary' : 'bg-white',
            ]"
          >
            <p
              class="fsize12 font-normal"
              :class="[
                event._id === selectedEvent._id ? 'text-white' : 'text-8f8f8f',
              ]"
            >
              {{ month[new Date(event.eventDate).getMonth()] }}
            </p>
            <h1
              class="font-semibold mb-0 text-4xl"
              :class="[
                event._id === selectedEvent._id ? 'text-white' : 'text-8f8f8f',
              ]"
            >
              {{ new Date(event.eventDate).getDate() }}
            </h1>
            <p
              class="fsize12 font-normal"
              :class="[
                event._id === selectedEvent._id ? 'text-white' : 'text-8f8f8f',
              ]"
            >
              {{ day[new Date(event.eventDate).getDay()] }}
            </p>
          </div>
          <div class="items-center w-8/12 pl-6">
            <div>
              <!-- <small class="fsize12 font-semibold col-4f">{{
                event.eventTitle
              }}</small> -->
              <h1 class="font-semibold text-dark mb-0 text-2xl">
                {{ event.eventTitle }}
              </h1>
              <small class="fsize12 font-medium text-8f8f8f">Industry</small>
            </div>
          </div>
          <!-- 
                <div class="w-2/12 flex justify-end pr-4">
                  <div
                    class="chevronup-css bg-primary rounded-full flex justify-center items-center text-white cursor-pointer"
                  >
                    <feather-icon icon="ChevronUpIcon" class="flex" />
                  </div>
                </div> -->
        </div>

        <div
          @click="selectEvent(event)"
          class="w-2/12 flex justify-end items-center pr-4"
        >
          <div
            class="chevronup-css bg-primary rounded-full flex justify-center items-center text-white cursor-pointer"
          >
            <feather-icon icon="ChevronRightIcon" class="flex" />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="text-center mt-4">
      <vs-button
        type="success"
        class="rounded-full bg-success border-0 text-white font-medium fsize16 lg:py-4 mt-3 md:py-3 w-full sm-fsize14"
      >
        Customize your Calander
      </vs-button>
      <p
        class="fsize12 font-semibold cursor-pointer text-center mt-6 text-primary"
      >
        Get recommedtions for your industry
      </p>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    events: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      activeNames: ["1"],
      month: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      day: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      selectedEvent: "",
    };
  },

  watch: {
    events(newValue) {
      this.selectEvent(newValue[0]);
    },
  },

  methods: {
    selectEvent(item) {
      this.selectedEvent = item;
      this.$emit("selectEvent", item);
    },
  },
};
</script>
